import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import { ProductProvider } from './pages/ProductContext'; // ✅ Rettet sti
import theme from './theme';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <ProductProvider> {/* Nå kan alle komponenter bruke useProducts() */}
        <App />
      </ProductProvider>
    </ChakraProvider>
  </React.StrictMode>
);
